import React from 'react';
import { Col } from 'react-bootstrap';
import { IKPI } from '../../../../../../../model/measure/IMeasure';

export default function ItemKPI({ title, value }: IKPI) {
    return (
        <Col className="col-auto">
            <h4 className="text-primary mb-0">{value}</h4>
            <p className="mb-0">{title}</p>
        </Col>
    );
}
